import { Link } from "react-router-dom";
import { SITE, createWhatsAppLink } from "../config/site";
import HeroGallery from "./HeroGallery";

export default function Hero() {
  return (
    <section className="mx-auto max-w-7xl px-2 pt-8 sm:px-4 md:pt-10">
      <div className="relative overflow-hidden rounded-[2rem] border border-orange-100 bg-[radial-gradient(circle_at_top_left,_#fff7f3,_#ffffff_55%,_#fff4ee)] shadow-sm">
        <div className="grid gap-8 px-6 py-8 sm:px-8 sm:py-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:px-10">
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-white/80 px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#e46a2e]">
              New season arrivals
            </div>

            <h1 className="mt-5 max-w-3xl text-4xl font-black tracking-tight text-slate-950 sm:text-5xl lg:text-6xl">
              {SITE.heroTitle}
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
              {SITE.heroSubtitle}
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/sneakers"
                className="inline-flex items-center justify-center rounded-full bg-[#e46a2e] px-6 py-3 text-base font-semibold text-white transition hover:bg-[#cf5d27]"
              >
                Shop now
              </Link>
              <a
                href={createWhatsAppLink()}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-6 py-3 text-base font-semibold text-slate-700 transition hover:border-[#e46a2e] hover:text-[#e46a2e]"
              >
                WhatsApp us
              </a>
            </div>

            <div className="mt-8 grid gap-3 sm:grid-cols-3">
              <FeaturePill title="Call" value={SITE.phoneDisplay} />
              <FeaturePill title="Visit" value={SITE.locationLine} />
              <FeaturePill title="Email" value={SITE.email} />
            </div>
          </div>

          <div className="relative z-10">
            <HeroGallery />
          </div>
        </div>

        <img
          src="/urban-treks.banner.png"
          alt="Featured shoes"
          className="pointer-events-none absolute bottom-0 right-0 hidden h-[92%] w-auto max-w-none opacity-15 lg:block"
        />
      </div>
    </section>
  );
}

function FeaturePill({ title, value }) {
  return (
    <div className="rounded-2xl border border-orange-100 bg-white/90 px-4 py-3 shadow-sm">
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{title}</div>
      <div className="mt-1 truncate text-sm font-semibold text-slate-900">{value}</div>
    </div>
  );
}
